module.exports = __webpack_public_path__ + "media/CN_011.f3312f2f.mp3";